import { ProtectedComponent } from '@components'

import { Button, Flex, Icon, Spacing, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useOpenConnectBankModal } from '@features/bankAccounts/hooks/useOpenConnectBankModal'
import { UiSource } from '@features/reconciliation/enums'

import { Scope } from '../../../../../../enums/scope'
import * as Styled from './styles'

interface SandboxModeBannerProps {
  onClose: () => void
  onReset: () => void
}

export const SandboxModeBanner = ({ onClose, onReset }: SandboxModeBannerProps): ReactElement => {
  const { t } = useTranslation()
  const openConnectBankModal = useOpenConnectBankModal()

  const handleConnectBankClick = useCallback(() => {
    openConnectBankModal(UiSource.Demo)
    onClose()
  }, [openConnectBankModal, onClose])

  return (
    <Styled.BannerWrapper>
      <Styled.MessageWrapper>
        <Icon icon="info" />
        <Text variant="bodyMD">
          <Text as="span" weight="bold">
            {t('bank_transactions.sandbox.banner_message_bold')}
          </Text>{' '}
          {t('bank_transactions.sandbox.banner_message_detail')}
        </Text>
      </Styled.MessageWrapper>
      <Flex gap={Spacing.S8} alignItems="center">
        <Button size="sm" variant="text" icon="refresh" onClick={onReset}>
          {t('bank_transactions.sandbox.reset_button')}
        </Button>
        <ProtectedComponent scopes={Scope.BankSyncWrite}>
          <Styled.ConnectBankButton size="sm" variant="tonal" icon="unplug" onClick={handleConnectBankClick}>
            {t('bank.accounts.list.card.actions.connect')}
          </Styled.ConnectBankButton>
        </ProtectedComponent>
        <Button size="sm" variant="filled" onClick={onClose}>
          {t('bank_transactions.sandbox.close_button')}
        </Button>
      </Flex>
    </Styled.BannerWrapper>
  )
}
